
import { IPerson, defaultPerson } from 'features/production/models/Person';

export interface IEmployee {

    id: number,
    
    personId: number,

    firstName: string,
    lastName: string,

    person: IPerson,

    salaryPeriodicity: 'd' | 'w' | 'M' | 'y',
    employeeCategory: string,

    registrationNumber: string,
    hiringDate: Date,
    status: string,
    statusDate: Date,

    lastDiploma: string,
    specialization: string,
    diplomaDate: Date,
    
    serviceCode: string,
    functionCode: string,
    employeeType: string,      

    hasSocialSecurity: boolean,
    socialSecurityNumber: string,

    employeeSalaryItems: IEmployeeSalaryItem[]
  }

  export interface IEmployeeSalaryItem {
    id: number,

    employeeId: number,
    salaryComponentId: number,

    defaultAmount: number,
    amountExpression: string,

    salaryComponentName: string
  }

    
  export const defaultEmployee : IEmployee = {
    id: 0,
    
    personId: 0,

    firstName: '',
    lastName: '',

    person: defaultPerson,

    salaryPeriodicity: 'M',
    employeeCategory: '',

    registrationNumber: '',
    hiringDate: new Date(),
    status: '10',
    statusDate: new Date(),

    lastDiploma: '',
    specialization: '',
    diplomaDate: new Date(),
    
    serviceCode: '',
    functionCode: '',
    employeeType: '',    

    hasSocialSecurity: false,
    socialSecurityNumber: '',

    employeeSalaryItems: []
  }

  
  export interface IEmployeeSearch {
    
    firstName: string,
    lastName: string,        
  }